var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.selectedColor)?_c('v-avatar',{staticClass:"mr-4",attrs:{"color":_vm.selectedColor,"size":"20"}}):_c('span',[_vm._v("--")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }